import { useMutation } from '@tanstack/react-query';
import { setAxiosAuth } from 'utils';
import { postLicense } from 'core/api/customers/customer.api';

export const usePostLicense = ({ accessToken = '' }) => {
  setAxiosAuth(accessToken);

  return useMutation({
    mutationFn: postLicense,
    retry: 0,
  });
}
